module.exports = __webpack_public_path__ + "img/dustland_slide_3.1969e0f0.jpg";